import React from "react";
import TodoForm from "../../component/TodoList/TodoForm.tsx";
import TodoTable from "../../component/TodoList/TodoTable.tsx";

const TodoListPage = () => {
  return (
    <div>
      {/* <TodoForm /> */}
      <TodoTable />
    </div>
  );
};

export default TodoListPage;
